import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useFormattedDate } from "@/hooks/metrics/useFormattedDate";

export function DateCell(props: GridRenderCellParams) {
  const formatted = useFormattedDate(props.value);
  return <>{formatted}</>;
}
